/* eslint-disable no-debugger */
/**
 *
 * Theme
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { Theme as StyledTheme } from '@cashfree-intl/coherent';
import { makeSelectEnv } from 'containers/MainLayout/selectors';
import { useSelector } from 'react-redux';
import { appSelector } from 'containers/App/selectors';

import {
  isICICIDashboard,
  isLKDashboard,
  isIDFCDashboard,
  isAxisDashboard,
} from '../../utils/common';
import designTokens from '../../utils/designTokens';
import {
  ICICIMERCHANT,
  LENDINGKARTMERCHANT,
  IDFCMERCHANT,
  AXISEASYPAYPLUS,
  IMPORTS_TEST_MERCHANT,
  IMPORTS_PROD_MERCHANT,
} from '../../utils/constants';

function Theme(props) {
  const loadState = useSelector(makeSelectEnv());
  const { featureFlags = {} } = useSelector(appSelector()) || {};

  let theme = null;
  document.querySelector('html').className = 'default';

  if (isICICIDashboard()) {
    document.querySelector('html').className = 'icici-eazypro';
    theme = designTokens[ICICIMERCHANT];
  } else if (isLKDashboard()) {
    document.querySelector('html').className = 'lending-kart';
    theme = designTokens[LENDINGKARTMERCHANT];
  } else if (isIDFCDashboard()) {
    document.querySelector('html').className = 'idfc';
    theme = designTokens[IDFCMERCHANT];
  } else if (isAxisDashboard()) {
    document.querySelector('html').className = 'axis-easypayplus';
    theme = designTokens[AXISEASYPAYPLUS];
  } else if (
    featureFlags.isMerchantImportEnabled && loadState
      ? ['test', 'sandbox'].includes(loadState)
      : props.env === 'test'
  ) {
    theme = designTokens[IMPORTS_TEST_MERCHANT];
  } else if (
    featureFlags.isMerchantImportEnabled && loadState
      ? loadState === 'prod'
      : props.env === 'prod'
  ) {
    theme = designTokens[IMPORTS_PROD_MERCHANT];
  }
  return <StyledTheme theme={theme}>{props.children}</StyledTheme>;
}

Theme.propTypes = {
  children: PropTypes.element.isRequired,
  env: PropTypes.string,
};

export default memo(Theme);
